export default {
    stripe: 'Stripe',
    moneris: 'Moneris',
    paypal: 'Paypal',
    'paypal-pro': 'Paypal Pro'
    // "square": "Square"
};
